export const SET_M6_REQUEST = 'SET_M6_REQUEST';
export const SET_M6_FAILED = 'SET_M6_FAILED';
export const SET_M6_SEGMENTS_SUCCESS = 'SET_M6_SEGMENTS_SUCCESS';
export const CLEAN_M6 = 'CLEAN_M6';
